import * as React from 'react';
import { Fragment } from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Translate from './Translate';
import Document from './Document';
import Disclaimers from './Disclaimers';

const LiteratureWrapper = styled<any, any>('div')`
    ${propStyles};
`;

LiteratureWrapper.defaultProps = {
    paddingX: ['md', 'xl'],
    paddingY: 'md',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: ['none', 'solid none none none'],
};

const LiteratureHeading = styled<any, any>('h2')`
    ${propStyles};
`;

LiteratureHeading.defaultProps = {
    display: ['none', 'block'],
    marginX: 'sm',
    marginY: 'sm',
    fontFamily: 'heading',
    fontWeight: 'medium',
    fontSize: 'sm',
};

const DocumentsList = styled<any, any>('ul')`
    ${propStyles};
`;

DocumentsList.defaultProps = {
    display: 'flex',
    flexDirection: ['column', 'row'],
    flexWrap: 'wrap',
};

const FundDocuments: React.SFC<any> = ({
    theme,
    groupedDocuments,
    documentDownloads,
    toggleDownload,
    documentSelected,
    selectedDocumentsLabel,
    availableDocumentsLabel,
    fundCardDisclaimers,
    noDocumentsDisclaimers,
}) => (
    <LiteratureWrapper {...theme.LiteratureWrapper}>
        {groupedDocuments.length === 0 ? (
            <Disclaimers
                disclaimers={noDocumentsDisclaimers}
                theme={{
                    ...theme,
                    DisclaimersList: theme.NoDocumentsDisclaimersList,
                    DisclaimerListItem: {
                        justifyContent: 'center',
                        ...theme.NoDocumentsDisclaimerListItem,
                    },
                    DisclaimerContent: {
                        paddingX: 'md',
                        paddingY: 'md',
                        fontFamily: 'heading',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        ...theme.NoDocumentsDisclaimerContent,
                    },
                }}
            />
        ) : (
            <Fragment>
                <LiteratureHeading {...theme.LiteratureHeading}>
                    <Translate>Fund Literature</Translate>
                </LiteratureHeading>
                <DocumentsList {...theme.DocumentsList}>
                    {groupedDocuments.map((documentGroup, index) => (
                        <Document
                            key={index}
                            index={index}
                            documentGroupName={documentGroup.documentGroupName}
                            documents={documentGroup.documents}
                            documentDownloads={documentDownloads}
                            toggleDownload={toggleDownload}
                            documentSelected={documentSelected}
                            selectedDocumentsLabel={selectedDocumentsLabel}
                            availableDocumentsLabel={availableDocumentsLabel}
                        />
                    ))}
                </DocumentsList>
            </Fragment>
        )}
        <Disclaimers
            disclaimers={fundCardDisclaimers}
            theme={{
                ...theme,
                DisclaimersList: theme.DocumentsDisclaimersList,
                DisclaimerListItem: theme.DocumentsDisclaimerListItem,
                DisclaimerContent: theme.DocumentsDisclaimerContent,
            }}
        />
    </LiteratureWrapper>
);

export default withTheme(observer(FundDocuments)) as any;



// WEBPACK FOOTER //
// ./src/Components/FundDocuments.tsx